<div class="p-3 bg-white">
  <div class="version-info text-custom-purple font-weight-bold">
    {{ data[0].versionID }}
  </div>
  <div class="d-flex flex-column py-2" *ngFor="let list of data">
    <div class="pb-3">
      <h5 class="text-secondary">
        {{ list.versionID }}
      </h5>
      <div class="version-info text-custom-purple">
        {{ list.versionRelaseDate }}
      </div>
      <ul class="pl-4 m-0" *ngFor="let info of list.versionInfos">
        <li class="version-info text-secondary">{{ info }}</li>
      </ul>
    </div>
    <hr class="w-100 my-1" />
  </div>
</div>
